var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleepBed = function SvgSleepBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 7.1v5.71m0 3.05V12.8m0 0h16v3.05",
    vectorEffect: "non-scaling-stroke"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.05,
    cy: 10.14,
    r: 1.52,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.1 9.38v-1a1 1 0 0 0-1 1h1Zm0 3.43h-1v1h1v-1Zm8.38 0v1h.84l.14-.84-.98-.16Zm-3.43-3.43v-1 1Zm-5.95 0v3.43h2V9.38h-2Zm1 4.43h8.38v-2H7.1v2Zm9.36-.84c.07-.43-.03-.92-.16-1.33-.15-.45-.4-.95-.74-1.42a4.3 4.3 0 0 0-3.51-1.84v2c.85 0 1.47.44 1.9 1.02.21.3.36.6.45.87.1.3.08.42.09.38l1.97.32Zm-4.41-4.59H7.1v2h4.95v-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.1 6.33H4.8l2.3-2.28H4.8M12.43 4.05H9.38L12.43 1H9.38",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgSleepBed;